import * as React from 'react';
import { createRoot } from 'react-dom/client';

import { App } from 'app';
import { installFetchLog } from 'app/apiLog';
import { applyBrandColors } from 'app/branding';

// Before anything else fetches: the console API log (pih.api(true)) times every call from here on.
installFetchLog();
// Before the first paint: the brand's primary colour as CSS variables (see branding.ts).
applyBrandColors();


async function enableMocking() {
    if (import.meta.env.MODE !== 'mock') {
        // A mock service worker registration from an earlier `pnpm mock` session in this same
        // browser profile survives across dev-server restarts/modes (service workers persist
        // until explicitly unregistered) and would keep intercepting every request on this
        // origin - including module script loads - causing hard-to-diagnose first-load
        // failures in a normal (non-mock) run. Clear it out defensively.
        if ('serviceWorker' in navigator) {
            const registrations = await navigator.serviceWorker.getRegistrations();
            await Promise.all(registrations.map((registration) => registration.unregister()));
        }
        return;
    }

    const { worker } = await import('./mocks/browser');

    // `worker.start()` returns a Promise that resolves
    // once the Service Worker is up and ready to intercept requests.
    return worker.start();
}

enableMocking().then(() => {
    createRoot(document.getElementById('root') as HTMLElement).render(
        <React.StrictMode>
            <App />
        </React.StrictMode>
    );
});
